import { Injectable } from '@angular/core';
import {UserInfoService} from "../user-info.service";
import {ConfigService, RbxRubixConfiguration, RbxFeatureFlags} from "../../../swaggerServices";

import { GlobalConfig } from "./config-states";
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigStateService {

  configLoaded = false;
  config: RbxRubixConfiguration = {
    dataType: "object",
    tenant: "common",
    featureFlags: {
      atlasSftpIntegration: false,
      aps: false,
      notices: false,
      auQnrs: false,
      auRobots: false,
      questionnaireRequiredTaxReturn: true,
      skipGenerationIfNoChange: false,
      syncPackageGeneration: false,
      requireClientApproval: false,
      selectPackageTemplates: false,
      amendmentRevisionCount: false,
      sourceUploadAppendOrReplace: false,
      checkUnsignedDocs: false,
      addSpouseRequireTaxId: false,
      taxReturnBulkAction: false,
      bulkTaxReturnStatusUpdate: false,
      moveAssigneeToDifferentClient: true,
      bulkMoveAssigneeToPopulation: false,
      preparerCanReturnBackForChanges: false,
      enableOneteamIntegration: false,
    } as RbxFeatureFlags,
  };

  configObservable: Observable<ConfigStateService> = new Observable(observer => {
    this.configService.getConfig().subscribe(cfg => {
      this.config = cfg;

      GlobalConfig.tenant = this.config.tenant;
      GlobalConfig.featureFlags = this.config.featureFlags;
      this.configLoaded = true;
      observer.next(this);
    }, e => {
      // try again in 15s...
      setTimeout(() => this.loadConfig(), 15000);
    });
  });

  constructor(private userInfo: UserInfoService, private configService: ConfigService) {
    this.loadConfig();
    
    userInfo.loginStateChanged.subscribe((loggedIn: boolean) => {
      if (loggedIn) {
        this.loadConfig();
      }
    });
  }

  // Config is loaded dynamically from the server after login. (For now the config route requires auth.)
  // If we fail to load the config, try again after a timeout and keep trying until success.
  loadConfig(): Observable<ConfigStateService> {
    if (this.configLoaded) {
      return of(this);
    }
    return this.configObservable;
  }

  // If data is critical on first page load, call loadConfig() and subscribe to changes
  get tenant(): string {
    return this.config.tenant;
  }

  // If data is critical on first page load, call loadConfig() and subscribe to changes
  get featureFlags(): RbxFeatureFlags {
    return this.config.featureFlags;
  }

}
